<template>
    <div class="statusInfoContain">
        <div class="module-result-content-status">
            <div class="result-content-status">
                <el-table
                        :data="statusList"
                        height="calc(100vh - 160px)"
                        :header-cell-style="{fontSize:'14px',fontWeight:'500'}"
                        width="calc(100vw - 180px)"
                        row-key="id"
                        :row-style="{fontSize:'14px',cursor:'pointer'}"
                        :row-class-name="getRowClass"
                >
                    <el-table-column
                           type="index"
                           width="100"
                           style="margin-left: 50px"
                           label="顺序"
                           align="center"
                    >
                        <template scope="scope">
                            <slot name="change" v-if="count">
                                <span class="statusInfoNum">{{scope.$index+1}}</span>
                            </slot>
                            <slot name="change" v-if="!count">
                                <span class="statusInfoNum" style="cursor: move" @mouseenter="resortStatus">
                                    <i class="arsenal_icon arsenalpaixu" style="font-size: 20px"></i>
                                </span>
                            </slot>
                        </template>
                    </el-table-column>

                    <el-table-column
                            label="状态"
                            width="150"
                            align="center"
                            :show-overflow-tooltip="true"
                    >
                        <template scope="scope">
                            <div class="statusInfoName">

                                <button :class="scope.row.color" >
                                    <div style="overflow:hidden;text-overflow: ellipsis;white-space: nowrap">
                                      {{scope.row.name}}
                                    </div>
                                </button>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="状态属性"
                            align="center"
                            width="150"

                    >
                        <template scope="scope">
                            <div class="statusInfoAttribute">
                                {{scope.row.closed |closedStatus}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="下一级状态"
                            :show-overflow-tooltip="true"
                    >
                        <template slot-scope="scope">
                            <div class="statusInfoNextStatus" v-if="scope.row.nextStatus!==null">
                                <span v-for="(item,index) in scope.row.nextStatus" :key="index" v-if="item!==null">
                                    {{index===0?item.name:","+item.name}}
                                </span>
                                <span v-else>--</span>
                            </div>
                            <div v-else>--</div>
                        </template>
                    </el-table-column>


                    <el-table-column
                            label="操作"
                            width="140"
                            align="center"
                    >
                        <template scope="scope">
                            <div class="StatusInfoOperation">
                                <div class="StatusInfoOperationBtn">
                                    <div class="reviseBtn">
                                        <el-button size="small" type="primary" icon="el-icon-edit" circle @click="resiveStatusClick(scope.row.id,scope.row)"></el-button>
                                      </div>
                                    <div class="operDeleteBtn" v-if="scope.row.deletable==null || scope.row.deletable">
                                        <el-button size="small" type="danger" icon="el-icon-delete" circle @click="deleteStatus(scope.row.id,scope.row._count,scope.row)"></el-button>
                                    </div>
                                    <div class="operDelete2Btn" v-else-if="items.name==='新建'"></div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>


                </el-table>
                <el-dialog  :visible.sync="dialogFormVisible1"  title="编辑状态" style="text-align: left;" custom-class="defaultDialog" :close-on-click-modal="false">
                    <div class="defalutAddStatus">
                        <div class="defalutAddStatusText"><span class="bixuan">*</span>状态名称</div>
                        <el-input v-model=statusName autocomplete="off"  placeholder="请输入字段名称" maxlength="8" class="defalutAddStatusInput"></el-input>
                    </div>
                    <div class="StatusColor">
                        <div class="statusColorText">状态颜色</div>
                        <div class="color">
                            <el-row :gutter="10">
                                <el-col :span="2" v-for="(color,index) in colorList" :key="index">
                                    <div class="colorItem" :class="color" @click="oneClick(color)">
                                        <i class="el-icon-check" v-if="check===color"></i>
                                    </div>
                                </el-col>

                            </el-row>


                        </div>
                    </div>

                    <div class="defaultinfoOptionAttr">
                        <div class="defaultinfoOptionText">状态属性</div>
                        <div class="defaultinfoRadio">
                            <el-radio v-model="closed" :label=false>未关闭</el-radio>
                            <el-radio v-model="closed" :label=true @change="closeStatus">已关闭</el-radio>
                        </div>
                    </div>
                    <div class="defalutNextStatus">
                        <div class="defaultNextStatusText">下一级状态</div>
                        <el-select class="defaultNextStatusSelect"
                                   v-model="nextStatusIds"
                                   multiple
                                   placeholder="请选择"
                        >
                            <el-option
                                    v-for="item in nextStatusList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>

                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
                        <el-button type="primary" @click="modifyStatusClick">确 定</el-button>
                    </div>
                </el-dialog>

                <el-dialog  :visible.sync="dialogFormVisible" custom-class="statusinfoDialog" title="删除状态" :close-on-click-modal="false">
                    <div class="statusinfoDialogText">您删除的<span style="font-size: 16px;font-weight: 600">{{deleteStatusName}}</span>状态下下有<span style="font-size: 16px;font-weight: 600">{{statusNum}}</span>个工单，需要将这些工单状态修改为</div>
                    <el-select v-model="statusSelect" class="statusinfoDialogSelect">
                        <el-option
                                v-for="item in selectStatusList"
                                :value="item.id"
                                :key="item.id"
                                :label="item.name"
                        >

                        </el-option>
                    </el-select>

                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogFormVisible = false">取 消</el-button>
                        <el-button type="danger" @click="deleteStatusInfo">确 定</el-button>
                    </div>
                </el-dialog>


            </div>


        </div>
        <el-dialog
                title="系统属性"
                :visible.sync="dialogVisible"

                custom-class="defaultDialog" :close-on-click-modal="false"
        >
            <div style="font-size: 14px;line-height: 24px">系统只允许存在一个已关闭的状态，是否设置该状态为已关闭状态？</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelCloseStatus">取 消</el-button>
                <el-button type="primary" @click="cnfirmCloseStatus">确 定</el-button>
              </span>
        </el-dialog>

    </div>
</template>

<script>
    import Sortable from "sortablejs";

    export default {
        name: "StatusInfo",
        props:{
            items:{
                type:Object,
                default(){
                    return {}
                }
            },
            count:{
                type:Boolean
            },
            index:Number,
            statusList:{
                type:Array,
                default(){
                    return []
                }
            }
        },
        data(){
            return{
                num:4,
                dialogFormVisible: false,
                dialogFormVisible1: false,
                dialogFormVisible2: false,
                statusName:'',
                checkAll:[],
                check:'',
                finish:1,
                statusSelect:['选项1','选项2'],
                closed:true,
                nextStatus:{
                    list:[]
                },
                newStatus:{
                    list:[]
                },
                status:{
                    list:[]
                },
                nextStatusIds:[],
                newStatusList:{
                    list:[]
                },
                nextStatusList:[],
                dialogVisible:false,
                deleteStatusId:0,
                selectStatusList:[],
                deleteStatusName:'',
                deleteStatusCount:'',
                riveseStatusId:0,
                statusResort:[],
                statusNum:'',
                colorList:['blue','yellow','green','orange','bluePurple','darkGrey','grey','brown','red','redPurple','black'],
                statusInfo:{
                    id:'',
                    mainId:'',
                    uid:''
                },
                clueCount:0
            }
        },
        mounted() {
        },
        filters:{
            closedStatus(value){
                if(value===false){
                    return '未关闭'
                }
                if(value===true)
                {
                    return '已关闭'
                }
            },
        },
        methods:{
            //获取行样式
            getRowClass(){
              return 'statusRowClass'
            },
            oneClick(color){
                this.check=color
            },
            resiveStatusClick(statusId,statusDetail){
                console.log(statusId)
                this.check=statusDetail.color
                this.statusName=statusDetail.name
                this.nextStatusIds=[]
                this.nextStatusIds=statusDetail.nextStatusIds
                this.statusInfo.id=statusId
                this.closed=statusDetail.closed
                let nextStatusList=[]
                this.statusList.forEach((item)=>{
                        if(item.id!==statusId)
                        {
                            nextStatusList.push(item)
                        }

                    })
                this.nextStatusList=nextStatusList
                this.dialogFormVisible1=true
            },

            //修改状态信息
            modifyStatusClick(){
                if(this.statusName!=='')
                {
                    let status={
                        name:this.statusName,
                        color:this.check,
                        closed:this.closed,
                        nextStatusIds:this.nextStatusIds
                    }
                    this.$http.put('/scrm-api/followup-status/' + this.statusInfo.id,status).then(res=>{
                        console.log(res)
                        if (res.status===200){
                            this.$message.success('更改状态信息成功')
                            this.$emit('modifyStatusClick')
                        }

                    })
                    this.dialogFormVisible1=false
                }
                else
                    this.$message.error('请输入状态名称')

            },
            getClueCount(id,fun){
                let url='/scrm-api/followup-status/count-clue?statusId='+id
                this.$http.get(url).then(res=>{
                    console.log('res',res)
                    this.clueCount=res.data
                    fun()
                })
            },
            deleteStatus(statusId,count,status){
                this.getClueCount(statusId,()=>{
                    if (this.clueCount > 0){
                        this.$message({
                            message:'该状态下存在客户线索，不可删除',
                            duration:3000,
                            type:'warning'
                        })
                        return
                    }
                    else {
                        this.statusNum=count
                        this.statusInfo.id=statusId
                        this.deleteStatusName=status.name

                        this.$confirm('您确定删除'+'\xa0'+status.name+'\xa0吗?', '删除状态', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.$http.delete('/scrm-api/followup-status/'+statusId).then(res=>{
                                console.log(res)
                                if (res.status===200){
                                    this.$message.success('删除状态信息成功')
                                    this.$emit('deleteStatusInfo2')
                                }
                            })
                        }).catch(() => {
                            this.$message({
                                type: 'info',
                                message: '已取消删除',
                                duration:2000
                            });
                        });
                    }
                })


            },
            //删除状态信息
            deleteStatusInfo(){
                if(this.statusSelect!=='')
                {
                    this.$http.delete('/scrm-api/followup-status/'+this.statusInfo.id).then(res=>{
                        console.log(res)
                        /*if(res.data.code==='0'){
                            this.$message.success('删除状态信息成功')
                            this.$emit('deleteStatusInfo')
                        }*/
                    })
                    this.dialogFormVisible = false
                }
                else
                    this.$message.error('请选择要修改的状态值')


            },
            resortStatus(){
                let _this = this;
                let el = document.querySelector('.el-table__body-wrapper tbody');
                new Sortable(el,{
                    ghostClass: 'blue-background-class',
                    animation: 200,
                    easing: "cubic-bezier(1, 0, 0, 1)",
                    onUpdate:function(event){
                        //修改items数据顺序
                        let newIndex = event.newIndex,
                            oldIndex = event.oldIndex,
                            $li = el.children[newIndex],
                            $oldLi = el.children[oldIndex];
                        // 先删除移动的节点
                        el.removeChild($li)
                        // 再插入移动的节点到原有节点，还原了移动的操作
                        if(newIndex > oldIndex) {
                            el.insertBefore($li,$oldLi)
                        } else {
                            el.insertBefore($li,$oldLi.nextSibling)
                        }
                        // 更新items数组
                        let item = _this.statusList.splice(oldIndex,1)
                        _this.statusList.splice(newIndex,0,item[0])
                        // 下一个tick就会走patch更新

                    },
                });
                this.statusResort=_this.statusList
                console.log(this.statusResort)
                this.$emit('resortStatus', this.statusResort)
            },
            cancelCloseStatus(){
                this.closed=false
                this.dialogVisible=false
            },
            cnfirmCloseStatus(){
                this.closed=true
                this.dialogVisible=false
            },
            closeStatus(value){
                if(value)
                {
                    this.statusList.forEach(item=>{
                        if(item.closed===true)
                            this.dialogVisible=true
                    })
                }
            }
        }
    }
</script>

<style  lang="less">
@import "../../../assets/less/defaultorderstatus/statusinfo/statusinfo";

.module-result-content-status {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-left: 16px;
    .result-content-status {
        flex: 1;
        position: relative;
        .el-table {

            position: absolute;
            overflow: hidden;

        }
    }
}
    .statusRowClass{
        font-family: "Arial Normal", "Arial", sans-serif;
        height: 60px;
        line-height: 60px;
    }
</style>